// extracted by mini-css-extract-plugin
export var menuIcon = "_o5-0";
export var menuIconInline = "_o5-1";